import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { formatPhoneDisplay } from '@mdvip/shared/lib/phone';
import { useTranslation } from 'react-i18next';
import { BlankValue } from './BlankValue';

export interface PhoneCellProps {
  mobile: string | null;
  home: string | null;
}

/** The Phone column: mobile first, home below it. The icons tell them apart on screen; a label does for a screen reader. */
export function PhoneCell({ mobile, home }: PhoneCellProps) {
  const { t } = useTranslation('providers');
  if (!mobile && !home) return <BlankValue />;

  return (
    <div className="flex flex-col gap-1">
      {mobile && (
        <span className="flex items-center gap-2">
          <Icon name="mobileScreen" size="xs" className="text-muted-foreground" />
          <span className="sr-only">{`${t('memberViews.columns.mobile')} `}</span>
          <span className="tabular-nums">{formatPhoneDisplay(mobile)}</span>
        </span>
      )}
      {home && (
        <span className="flex items-center gap-2">
          <Icon name="phone" size="xs" className="text-muted-foreground" />
          <span className="sr-only">{`${t('memberViews.columns.home')} `}</span>
          <span className="tabular-nums">{formatPhoneDisplay(home)}</span>
        </span>
      )}
    </div>
  );
}
